import { ReactNode } from "react";
import { AppSidebar } from "@/ui/components/layout/app-sidebar";
import { CreateModalProvider, useCreateModal } from "@/contexts/CreateModalContext";
import { CreateTripModal } from "@/modules/trips";

interface AppShellProps {
  children: ReactNode;
  className?: string;
}

function AppShellInner({ children, className = "" }: AppShellProps) {
  const { open, closeCreateModal } = useCreateModal();

  return (
    <div className={`min-h-screen bg-earth-50 flex flex-row ${className}`}>
      <AppSidebar />
      <main className="flex-1 min-w-0 flex flex-col md:ml-[84px] pb-16 md:pb-0 min-h-screen">
        <div className="flex-1 min-w-0 min-h-0">{children}</div>
      </main>
      <CreateTripModal open={open} onOpenChange={(isOpen) => !isOpen && closeCreateModal()} />
    </div>
  );
}

/**
 * App shell for authenticated app: left sidebar + main content area.
 * No top header. Supports future three-column layout (list | center | panel) inside main.
 */
export function AppShell({ children, className = "" }: AppShellProps) {
  return (
    <CreateModalProvider>
      <AppShellInner className={className}>{children}</AppShellInner>
    </CreateModalProvider>
  );
}
